<template>
  <div>
    <va-modal
      :value="isOpen"
      ref="updateReportModal"
      :okText="$t('reports.reports.buttons.save')"
      :okClass="'btn btn-primary btn-micro'"
      :okToClose="false"
      @ok="submit"
      :cancelText="$t('reports.templates.buttons.back')"
      :cancelClass="'btn-cancelar btn btn-primary btn-micro'"
      @cancel="close"
    >
      <div slot="header" class="modal-title">
        <span>{{ $t('reports.reports.titles.update_report') + "-" + report.name }}</span>
      </div>

      <div class="evollu-form">

        <h5>
          <b>{{ $t('reports.reports.subtitles.report_info') }}</b>
        </h5>

        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <va-input
              id="report-name"
              :label="$t('reports.reports.labels.name')"
              v-model="updateReportForm.data.name"
              :placeholder="$t('reports.reports.labels.report_name_placeholder')"
              @input="updateReportForm.errors.clear('name')"
              :error="updateReportForm.errors.has('name')"
              :error-messages="[$t(updateReportForm.errors.get('name'))]"
            />
          </div>

          <div class="col-12 col-md-6 mb-3 input-disabled">
            <va-input
              :disabled="true"
              id="report-client"
              :label="$t('reports.reports.labels.client')"
              :value="report.client.name"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <va-input
              :disabled="true"
              id="report-date-period"
              :label="$t('reports.reports.labels.date_period')"
              :value="`${this.moment(this.report.start_date).format('YYYY-MM-DD')} - ${this.moment(this.report.end_date).format('YYYY-MM-DD')}`"
            />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <va-input
              :disabled="true"
              id="report-total-value"
              :label="$t('reports.reports.labels.report_total_value')"
              :value="`${presentTotalValue(report.total_value)}€`"
            />
          </div>

        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <va-input
              :disabled="true"
              id="report-is-control"
              :label="$t('reports.reports.labels.is_control')"
              :value="report.is_control ? $t('reports.reports.labels.is_control_true') : $t('reports.reports.labels.is_control_fase')"
            />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <label class="fixed-label"><b
              class="title-label">{{ $t('reports.reports.labels.report_state') }}</b></label>
            <div class="d-flex mt-2">
              <slider v-model="updateReportForm.data.locked"></slider>
              <span
                class="ml-3">{{ updateReportForm.data.locked ? $t('reports.reports.labels.report_state_locked') : $t('reports.reports.labels.report_state_unlocked') }}</span>
            </div>
          </div>

        </div>

        <div class="row" v-if="!report.is_control && report.client_type !== 1 && updateReportForm.data.locked">
          <va-checkbox
            class="col"
            v-model="updateReportForm.data.send_lock_email"
            :label="$t('reports.reports.labels.send_lock_email')"
          />
        </div>
      </div>

      <hr>

      <div class="evollu-form">

        <h5>
          <b>{{ $t('reports.reports.subtitles.invoice_info') }}</b>
        </h5>

        <div class="row">

          <div class="col-12 col-md-6 mb-3">
            <va-input
              id="report-invoice-number"
              type="text"
              placeholder="---"
              :label="$t('reports.reports.labels.invoice_number')"
              v-model="updateReportForm.data.invoice_number"
              @input="updateReportForm.errors.clear('invoice_number')"
              :error="updateReportForm.errors.has('invoice_number')"
              :error-messages="[$t(updateReportForm.errors.get('invoice_number'))]"
            />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <date-picker
              id="date-picker-range"
              v-model="updateReportForm.data.invoice_date"
              :label="$t('reports.reports.labels.invoice_date')"
              :config="{enableTime: false, dateFormat: 'Y-m-d'}"
              @input="updateReportForm.errors.clear('invoice_date')"
              :error="updateReportForm.errors.has('invoice_date')"
              :error-messages="[$t(updateReportForm.errors.get('invoice_date'))]"
            />
          </div>
        </div>

        <div class="row"
             v-if="!report.is_control && report.client_type !== 1 && (updateReportForm.data.invoice_date || updateReportForm.data.invoice_number)">
          <va-checkbox
            class="col"
            v-model="updateReportForm.data.send_invoice_email"
            :label="$t('reports.reports.labels.send_invoice_email')"
          />
        </div>
      </div>

      <hr>

      <div class="evollu-form">

        <h5>
          <b>{{ $t('reports.reports.subtitles.payment_info') }}</b>
        </h5>

        <div class="row">

          <div class="col-12 col-md-6 mb-3">
            <date-picker
              id="date-picker-selected-time"
              v-model="updateReportForm.data.payment_date"
              :label=" $t('reports.reports.labels.payment_date') "
              :config="{enableTime: false, dateFormat: 'Y-m-d'}"
              @input="updateReportForm.errors.clear('payment_date')"
              :error="updateReportForm.errors.has('payment_date')"
              :error-messages="[$t(updateReportForm.errors.get('payment_date'))]"
            />
            <small v-show="updateReportForm.errors.has('payment_date')" class="help text-danger">
              {{ $t(updateReportForm.errors.get('payment_date')) }}
            </small>
          </div>
        </div>

        <div class="row" v-if="!report.is_control && report.client_type !== 1 && updateReportForm.data.payment_date">
          <va-checkbox
            class="col"
            v-model="updateReportForm.data.send_payment_email"
            :label="$t('reports.reports.labels.send_payment_email')"
          />
        </div>

      </div>

      <hr>

      <div class="evollu-form pb-4">
        <h5 class="mb-2">
          <b>{{ $t('reports.reports.subtitles.report_files') }}</b>
        </h5>

        <div class="row">
          <input id="excel-input" type="file" @change="onExcelSelected" hidden
                 accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          <div class="col-8">
            <span>
              <b>{{ $t('reports.reports.labels.excel_file') }}:</b>
            </span>
            <span class="small-text">{{ getFileName('xlsx') }}</span>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <va-popover
              placement="left"
              :message="$t('reports.reports.buttons.download_report')">
              <i class="report-action-icon fa fa-download pl-2 pr-2 clickable"
                 @click.prevent.stop="downloadExcel()"></i>
            </va-popover>
            <div>
              <va-popover
                v-if="!report.locked"
                placement="left"
                :message="$t('reports.reports.buttons.upload_report')">
                <i :class="[{'is-disabled': report.locked}, 'clickable']"
                   class="report-action-icon fa fa-upload pl-2 pr-2" @click.prevent.stop="uploadExcel()"></i>
              </va-popover>
            </div>
          </div>
        </div>

        <div v-if="updateExcelForm.data.excel && !report.locked" class="row mt-2">
          <div class="col-8">
            <span for="">
              <b>{{ $t('reports.reports.labels.new_excel_file') }}:</b>
            </span>
            <span class="small-text">{{ updateExcelForm.data.excel.name }}</span>
            <br>

          </div>
          <div class="col-4 d-flex justify-content-end">
            <va-popover
              placement="left"
              :message="$t('reports.reports.buttons.download_report')">
              <i :class="[{'is-disabled': report.locked}]" class="report-action-icon fa fa-pencil pl-2 pr-2"
                 @click.prevent.stop="uploadExcel()"></i>
            </va-popover>
            <va-popover
              placement="left"
              :message="$t('reports.reports.buttons.upload_report')">
              <i class="report-action-icon fa fa-times pl-2 pr-2" @click.prevent.stop="cancelExcelUpload()"></i>
            </va-popover>
          </div>
          <div class="col-12">
            <small v-show="updateExcelForm.errors.has('excel')" class="help text-danger">
              {{ updateExcelForm.errors.get('excel') | translate }}
            </small>
          </div>
        </div>

      </div>

    </va-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Slider from '@/components/common/Slider'
import Errors from '@/utils/StandardErrors'
import {ReportsService} from "@/api/ReportsService";
import DatePicker from "@/components/common/DatePicker";

const transitionDuration = 500

export default {
  props: {
    serviceUrl: {
      type: String,
      required: true
    },
    report: {
      type: Object,
      required: true
    }
  },
  components: {
    DatePicker,
    Slider
  },
  mounted: function () {
    this.isOpen = true
    this.prepareForUpdate()
  },

  data: function () {
    return {
      isOpen: false,
      updateReportForm: {
        data: {
          name: null,
          locked: false,
          send_lock_email: !this.report.locked,
          invoice_number: null,
          invoice_date: null,
          send_invoice_email: this.report.invoice_number === null,
          payment_date: null,
          send_payment_email: this.report.payment_date === null
        },
        errors: new Errors()
      },
      updateExcelForm: {
        data: {
          excel: undefined
        },
        errors: new Errors()
      }
    }
  },
  methods: {
    close: function () {
      setTimeout(() => {
        this.$emit('modalWasClosed')
      }, transitionDuration)
    },
    submit: function () {
      let requests = []

      requests.push(this.submitUpdateForm())

      if (!this.report.locked && this.updateExcelForm.data.excel !== undefined) {
        requests.push(this.submitExcel())
      }

      /*if (!this.report.locked && this.updateExcelForm.data.excel !== undefined) {
        this.submitExcel()
          .then(response => {
            this.updateExcelForm.errors.clear()
            this.showToast(this.$t('reports.reports.messages.successful_file_update'), this.$store.state.successToastOptions)
            this.$emit('update', response.data.data)
            this.cancelExcelUpload()
            this.submitUpdateForm().then(response => {
              this.showToast(this.$t('reports.reports.messages.successful_update'), this.$store.state.successToastOptions)
              this.$emit('update', response.data.data)
              this.isOpen = false
            }).catch(error => {
              if (error.response.status === 422) {
                this.updateReportForm.errors.record(error.response.data, 'reports.reports.errors.')
                this.showToast(this.$t('reports.reports.messages.unsuccesful_update'), this.$store.state.errorToastOptions)
              } else {
                this.showToast(this.$t('reports.reports.messages.something_went_wrong_report_data'), this.$store.state.errorToastOptions)
              }
            })
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.updateReportForm.errors.record(error.response.data, 'reports.reports.errors.')
              this.showToast(this.$t('reports.reports.messages.unsuccesful_update'), this.$store.state.errorToastOptions)
            } else {
              this.showToast(this.$t('reports.reports.messages.something_went_wrong_report_data'), this.$store.state.errorToastOptions)
            }
          })*/
      //requests.push(this.submitExcel())
      /*} else {
        this.submitUpdateForm().then(response => {
          this.showToast(this.$t('reports.reports.messages.successful_update'), this.$store.state.successToastOptions)
          this.$emit('update', response.data.data)
          this.isOpen = false
        }).catch(error => {
          if (error.response.status === 422) {
            this.updateReportForm.errors.record(error.response.data, 'reports.reports.errors.')
            this.showToast(this.$t('reports.reports.messages.unsuccesful_update'), this.$store.state.errorToastOptions)
          } else {
            this.showToast(this.$t('reports.reports.messages.something_went_wrong_report_data'), this.$store.state.errorToastOptions)
          }
        })
      }*/

      Promise.all(requests)
        .then(response => {
          this.$emit('update', response[response.length -1].data.data);
        })
        .catch(errors => console.log(errors))
    },
    submitUpdateForm: function () {
      return new Promise((resolve, reject) => {
        ReportsService.update(this.report.id, this.updateReportForm.data)
          .then(response => {
            //this.$emit('update', response.data.data)
            this.showToast(this.$t('reports.reports.messages.successful_update'), this.$store.state.successToastOptions)
            resolve(response)
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.updateReportForm.errors.record(error.response.data, 'reports.reports.errors.')
              this.showToast(this.$t('reports.reports.messages.unsuccesful_update'), this.$store.state.errorToastOptions)
            } else {
              this.showToast(this.$t('reports.reports.messages.something_went_wrong_report_data'), this.$store.state.errorToastOptions)
            }
            reject(error)
          })
      })
    },
    submitExcel: function () {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('excel', this.updateExcelForm.data.excel)
        ReportsService.submitExcel(this.report.id, formData)
          .then(response => {
            //this.$emit('update', response.data.data)
            this.updateExcelForm.errors.clear()
            this.showToast(this.$t('reports.reports.messages.successful_file_update'), this.$store.state.successToastOptions)
            this.cancelExcelUpload()
            resolve(response)
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.updateExcelForm.errors.record(error.response.data, 'reports.reports.errors.')
              this.showToast(this.$t('reports.reports.messages.unsuccessful_file_update'), this.$store.state.errorToastOptions)
            } else {
              this.showToast(this.$t('reports.reports.messages.something_went_wrong_report_file'), this.$store.state.errorToastOptions)
            }
            reject(error)
          })
      })
    },
    getFileName: function (mimeType) {
      return `${this.report.name}_${this.report.client.name}.${mimeType}`
    },
    downloadExcel: function () {
      ReportsService.downloadExcel(this.report.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.getFileName('xlsx'))
          document.body.appendChild(link)
          link.click()
        })
        .catch(errors => this.showToast(this.$t('reports.templates.messages.something_went_wrong'), this.$store.state.errorToastOptions))
    },
    uploadExcel: function () {
      this.updateExcelForm.errors.clear()
      if (!this.report.locked) {
        document.getElementById('excel-input').click()
      }
    },
    onExcelSelected: function (event) {
      this.updateExcelForm.data.excel = event.target.files[0]
    },
    cancelExcelUpload: function (event) {
      this.updateExcelForm.errors.clear()
      this.updateExcelForm.data.excel = undefined
      //document.getElementById('excel-input').value = ''
    },
    presentTotalValue: function (value) {
      return value === 0 ? String(0) : String(value / 100)
    },
    prepareForUpdate: function () {
      this.updateReportForm.data.name = this.report.name
      this.updateReportForm.data.locked = this.report.locked
      this.updateReportForm.data.invoice_number = this.report.invoice_number
      this.updateReportForm.data.invoice_date = this.report.invoice_date
      this.updateReportForm.data.payment_date = this.report.payment_date
    }

  }
}
</script>

<style lang="scss">
.evollu-form .va-input__container input:disabled {
  background-color: unset !important;
  color: red
}
</style>

<style scoped lang="scss">
label.fixed-label {
  justify-content: normal;
  font-size: 0.6rem;
  color: #29c4a9 !important;
  font-weight: 600;
  text-transform: uppercase;
  top: -0.6rem;
  left: 0;
  margin-bottom: 0;
}

.title-label {
  color: #29c4a9 !important;
}


</style>
